export enum SubjectEnum {
  "MyGame" = 1,
  "ACT English" = 2,
  "ACT Math" = 3,
  "ACT Reading" = 4,
  "ACT Science" = 5,
  "SAT Reading" = 6,
  "SAT Writing" = 7,
  "SAT Math" = 8,
  "Math 1" = 9,
  "Math 2" = 10,
  "Math 3" = 11,
  "Math 4" = 12,
  "Verbal" = 13,
  "Maths" = 14,
  "GCSE English" = 15,
  "GCSE Maths" = 16,
  "GCSE Science" = 17,
  "SAT English" = 18,
}
